// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__iJO7V","primary":"IconButton_primary__KzkR4","secondary":"IconButton_secondary__m4m0G","round":"IconButton_round__wY3W6"};